import { ContextMenuInputPoint } from '@thoughtspot/chart-common';
import { create } from '@thoughtspot/logger';
import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import Joi from 'joi';
import _ from 'lodash';
const logger = create('context-menu/util');
export const pointValSchema = Joi.object({
    columnId: Joi.string().required(),
    value: Joi.any().required(),
}).unknown(false);
export const pointSchema = Joi.object({
    tuple: Joi.array()
        .items(pointValSchema.required())
        .required(),
}).unknown(false);
const customActionSchema = Joi.object({
    id: Joi.string().required(),
    label: Joi.string().required(),
    icon: Joi.string().allow(null),
    onClick: Joi.func().required(),
}).unknown(false);
const openContextMenuEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    clickedPoint: pointSchema.required(),
    selectedPoints: Joi.alternatives().try(Joi.array()
        .items(pointSchema)
        .empty(), Joi.allow(null)),
    customActions: Joi.alternatives().try(Joi.array()
        .items(customActionSchema)
        .empty(), Joi.allow(null)),
}).unknown(false);
export const validatePointColumnId = (point, columns) => {
    point.tuple.forEach(pointVal => {
        const idx = columns.findIndex(col => col.id === pointVal.columnId);
        if (idx === -1) {
            logger.error('columnId in point is invalid. column not found', pointVal, point);
            throw new Error(`columnId in point is invalid. column with id:${pointVal.columnId} not found.`);
        }
    });
};
export const validateOpenContextMenuEventPayloadObject = (object, columns) => {
    try {
        Joi.assert(object, openContextMenuEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
    const points = [
        object.clickedPoint,
        ...(object.selectedPoints ?? []),
    ];
    points.forEach(point => {
        validatePointColumnId(point, columns);
    });
};
export const convertPointValToContextMenuInputValue = (point, columns) => {
    const contextMenuPoint = new ContextMenuInputPoint();
    point.tuple.forEach((pointVal) => {
        const colIdx = _.findIndex(columns, col => {
            return col.id === pointVal.columnId;
        });
        const col = columns[colIdx];
        contextMenuPoint.pushSelected({
            value: pointVal.value,
            column: col,
        });
    });
    return contextMenuPoint;
};
export const updateCustomActionOnClickCallback = (customActions, emitEvent, clickedPoint, selectedPoints, event) => {
    return customActions?.map(action => {
        return {
            ...action,
            onClick: () => emitEvent(TSToChartEvent.ContextMenuActionClick, {
                id: action.id,
                clickedPoint,
                selectedPoints,
                event,
            }),
        };
    });
};
export const testHooks = {
    pointValSchema,
    pointSchema,
    openContextMenuEventPayloadSchema,
    customActionSchema,
};
//# sourceMappingURL=util.js.map